<template>
  <div>
    <b-card class="bg-white rounded-xl product-list-container">
      <AddProductSidebar
        :isSidebarActive="openAddProductSidebar"
        @closeSidebar="toggleAddProductSidebar"
        @getAllProduct="getAllProduct"
      />
      <div class="flex justify-between items-center" id="ProductsID">
        <div>
          <h2 class="text-2xl font-semibold">Products</h2>

          <!-- <small class=" text-muted "
            >Lorem ipsum dolor sit amet, consectetur adipiscing elit,
          </small> -->
        </div>
        <div class="flex">
          <div class="mr-4">
            <base-button
              outline
              type="primary"
              class="flex"
              @click="addProduct"
            >
              <feather-icon icon="PlusIcon" class="mr-1"></feather-icon>Add
              Product
            </base-button>
          </div>
          <!-- <div>
            <base-button outline type="primary" class="flex">
           
              <a href="#hello">Pending Request</a>
            </base-button>
          </div> -->
        </div>
      </div>
      <b-input-group class="mt-6">
        <b-form-input
          class="border-none shadow-lg"
          type="text"
          min="0.00"
          v-model="search"
          placeholder="Enter Search...."
        ></b-form-input>

        <b-input-group-append>
          <b-button
            variant="white"
            class="flex items-center shadow-lg"
            aria-label="search"
            @click="getAllProduct"
          >
            <feather-icon
              class="cursor-pointer mr-2"
              icon="SearchIcon"
              svgClasses="w-4 h-4"
            ></feather-icon>
          </b-button>
        </b-input-group-append>
      </b-input-group>

      <div class="mt-8" v-if="tableData.length != 0">
        <ProductsCard
          :item="item"
          v-for="item in tableData"
          :key="item._id"
          @getAllProduct="getAllProduct"
        />

        <!-- {{ this.tableData }} -->
        <!-- <div class="pt-20">
          <PendingReq
            :item="item"
            v-for="(item, index) in products"
            :key="'item -' + index"
            id="hello"
            class=""
          />
        </div> -->
      </div>
      <div class="mt-9" v-else>No Data</div>
      <b-card-footer class="py-4 d-flex justify-content-end">
        <b-pagination
          v-model="currentPage"
          :total-rows="totalRows"
          :per-page="perPage"
          @change="handlePageChange"
          aria-controls="my-table"
        ></b-pagination>
      </b-card-footer>
    </b-card>
  </div>
</template>

<script>
import "../../scss/Index.scss";

import ProductsCard from "./components/ProductsCard";
import { mapState } from "vuex";
import AddProductSidebar from "./components/AddProductSidebar";

export default {
  components: {
    ProductsCard,
    AddProductSidebar,
  },
  data() {
    return {
      tableData: [
        // {
        //   title: "Gifts Of Love - Key to Happiness",
        //   img: require("../../../../assets/images/allproducts/1.jpg"),
        //   description:
        //     "Lorem ipsum dolor sit amet, consectetur adipiscing elit.Lorem ipsum dolor sit amet, consectetur adipiscing elit.Lorem ipsum dolor sit amet, consectetur adipiscing elit Lorem ipsum dolor sit amet, consectetur adipiscing elit. m dolor sit amet, consectetur adipiscing elit Lorem ipsum dolor sit amet, consectetur adipiscing elit. m dolor sit amet, consectetur adipiscing elit Lorem ipsum dolor sit amet, consectetur adipiscing elit.",
        // },
        // {
        //   title: "Gifts Of Love - Dear Zindagi",
        //   img: require("../../../../assets/images/allproducts/2.jpg"),
        //   description:
        //     "Lorem ipsum dolor sit amet, consectetur adipiscing elit.",
        // },
        // {
        //   title: "Asili Natural Hamper - Dear Zindagi",
        //   img: require("../../../../assets/images/allproducts/3.jpg"),
        //   description:
        //     "Lorem ipsum dolor sit amet, consectetur adipiscing elit.",
        // },
      ],
      openAddProductSidebar: false,

      search: "",
      totalRows: 0,
      perPage: 10,
      currentPage: 1,
    };
  },
  watch: {
    async currentPage() {
      await this.getAllProduct();
    },
    search: {
      handler: _.debounce(async function (val) {
        this.getAllProduct();
      }, 500),
    },
  },
  computed: {
    ...mapState("affiliate", {
      products: "products",
      brandData: "brandData",
    }),
  },
  methods: {
    scrollToTop() {
      setTimeout(() => {
        const element = document.getElementById("ProductsID");
        if (element) {
          element.scrollIntoView({ behavior: "smooth", block: "start" });
        }
      }, 10);
    },

    addProduct() {
      this.toggleAddProductSidebar(true);
    },
    toggleAddProductSidebar(val = false) {
      this.openAddProductSidebar = val;
    },

    async getAllProduct() {
      let payload = {
        limit: this.perPage,
        offset: (this.currentPage - 1) * this.perPage,
        isAdminRequest: "true",
      };
      //  offset: this.currentPage > 1 ? (this.currentPage - 1) * 10 : 0,

      if (this.search !== "")
        Object.assign(payload, { search: this.search.trim() });
      let loader;
      try {
        // console.log(payload);
        loader = this.$loading();
        const allProduct = await this.$store.dispatch(
          "affiliate/getAllProduct",
          payload
        );

        // console.log(allProduct);
        loader.close();

        this.totalRows = this.products.totalCount;
        this.tableData = this.products.result;
        // console.log(this.products);
      } catch (error) {
        console.log(error);
        loader.close();
      }
    },
    handlePageChange(page) {
      this.currentPage = page;
      this.getAllProduct();
      this.scrollToTop();
    },
  },
  async mounted() {
    await this.$store.dispatch("affiliate/getBrand");
    await this.$store.dispatch("subscribe/GetAllMembership");
    await this.$store.dispatch("subscribe/GetCoupon", {
      getAll: true,
    });
    await this.getAllProduct();
  },
};
</script>
